import React from "react";
import { useLocation } from "react-router-dom";
import Header from "../header/header";
import Footer from "../footer/footer";

// Routes that provide their own chrome. Matched by prefix: the previous exact
// match meant /AdminDash showed the dashboard shell but /AdminDash/mainPage
// also rendered the public header on top of it.
const BARE_PREFIXES = ["/AdminDash"];

// Auth screens are full-bleed and carry their own back-links, so the public
// header would only compete with them.
const BARE_EXACT = ["/signin", "/signup"];

export default function Layout({ children }) {
  const { pathname } = useLocation();

  const bare =
    BARE_EXACT.includes(pathname) ||
    BARE_PREFIXES.some((p) => pathname === p || pathname.startsWith(p + "/"));

  if (bare) {
    return <div className="es-shell">{children}</div>;
  }

  return (
    <div className="es-shell">
      <Header />
      <main className="es-shell__main" id="main-content">
        {children}
      </main>
      <Footer />
    </div>
  );
}
